import { formatTextByNumber } from './src/string';

export default {
    install: (Vue) => {
        Vue.config.globalProperties.formatTextByNumber = formatTextByNumber;
    }
}
